import * as svg from "../../../assets/august-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const AugustIcon = iconBuilder(svg, "AugustIcon", "0 0 149.4 149.4");
